import { render, staticRenderFns } from "./LBS.vue?vue&type=template&id=07fa1756&"
import script from "./LBS.vue?vue&type=script&lang=js&"
export * from "./LBS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/aims-dashboard/aims-dashboard/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07fa1756')) {
      api.createRecord('07fa1756', component.options)
    } else {
      api.reload('07fa1756', component.options)
    }
    module.hot.accept("./LBS.vue?vue&type=template&id=07fa1756&", function () {
      api.rerender('07fa1756', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Multifunction/LBS.vue"
export default component.exports